const styles = {
    main: {
        marginTop: '10px',
        backgroundColor: '#191919',
        color: 'white',
        width: '100%',
        padding: '5px 50px 5px 0',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        '@media (max-width: 600px)': {
            width: '100vw',
            padding: '5px 30px 5px 0',
        },
    },
    gold: {
        '@media (max-width: 600px)': {
            backgroundColor: '#EAD19D',
        },
    },
    link: {
        paddingLeft: '5px',
    },
    linkText: {
        color: '#909090',
        textDecoration: 'none'
    }
};

export default styles;